import React from 'react';
import {
  List,
  ListItem,
  Typography,
  TextField,
  Grid,
  Button,
  responsiveFontSizes,
} from '@mui/material';
import onBoarding_icon from '../assets/login.svg';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import axios from '../services/axios';
import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import { logInWithEmailAndPassword } from '../repo/firebase';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import App from '../App';

const Login = (props) => {
  const [input, setInput] = useState({ email: '', password: '' });
  // const [user, loading, error] = useAuthState(auth);

  const [uid, setUID] = useState({uidno : "Getting"})

  const navigate = useNavigate();

  let location = useLocation();

  let { from } = location.state || { from: { pathname: '/dashboard' } };

  const handleChange = (event) => {
    const name = event.currentTarget.name;
    const value = event.currentTarget.value;

    setInput({ ...input, [name]: value });
  };

  React.useState(() => {
    // localStorage.clear();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

      logInWithEmailAndPassword(input.email, input.password).then(response => {
       if(response==true){
        navigate("/dashboard")
       }
       else
       {
        alert("Responce is "+response)
       }
      })
    
    
  };

  return (
    <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
      <Grid
        item
        xs={6}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <List>
          <ListItem>
            <img
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '20%',
              }}
              src={onBoarding_icon}
              alt='Onboarding'
            ></img>
          </ListItem>
          <ListItem>
            <Typography
              variant='button'
              style={{
                fontWeight: 'bolder',
                paddingLeft: '10%',
                paddingRight: '10%',
              }}
            >
              Revolutionary Education based on artificial Intelligence and logic
              indicator. Artificial intelligence in eduction. The next digital
              frontier
            </Typography>
          </ListItem>
        </List>
      </Grid>

      <Grid
        item
        xs={6}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <List>
          <ListItem>
            <Typography
              style={{ paddingTop: '30%', fontWeight: 'bolder' }}
              variant='h2'
              align='Center'
            >
              Login to Real
            </Typography>
            <Typography
              style={{
                paddingTop: '30%',
                fontWeight: 'bolder',
                fontStyle: 'italic',
                color: '#608E99',
              }}
              variant='h2'
              align='Center'
            >
              
            </Typography>
          </ListItem>

          <AppInputFeild
            name='email'
            label='User id'
            type='email'
            onChange={handleChange}
          />
          <AppInputFeild
            name='password'
            label='password'
            type='password'
            onChange={handleChange}
          />

        
            <ListItem>
              <Button
                variant='contained'
                fullWidth='ture'
                style={{
                  minHeight: '60px',
                  minWidth: '600px',
                  backgroundColor: '#69557C',
                  borderRadius: '14px',
                }}
                onClick={handleSubmit}
              >
                <Typography variant='button' style={{ fontWeight: 'bolder' }}>
                  Login
                </Typography>
              </Button>
            </ListItem>

        </List>
      </Grid>
    </Grid>
  );
};

export default Login;

export function AppInputFeild(props) {
  return (
    <ListItem>
      <TextField
        style={{ borderRadious: '20%' }}
        fullWidth
        type={props.type}
        name={props.name}
        label={props.label}
        value={props.value}
        onChange={props.onChange}
      />
    </ListItem>
  );
}

export function AppButton(props) {
  return (
    <ListItem>
      <Button
        variant='contained'
        fullWidth='ture'
        style={{
          minHeight: '60px',
          minWidth: '600px',
          backgroundColor: '#69557C',
          borderRadius: '14px',
        }}
        onClick={props.onClick}
      >
        <Typography variant='button' style={{ fontWeight: 'bolder' }}>
          {props.title}
        </Typography>
      </Button>
    </ListItem>
  );
}

export function AppTitle() {
  return (
    <ListItem>
      <Typography
        style={{ paddingTop: '30%', fontWeight: 'bolder' }}
        variant='h1'
        align='Center'
      >
        Real
      </Typography>
      <Typography
        style={{
          paddingTop: '30%',
          fontWeight: 'bolder',
          fontStyle: 'italic',
          color: '#608E99',
        }}
        variant='h1'
        align='Center'
      >
        ι
      </Typography>
    </ListItem>
  );
}
